import { PointCategory } from '@shared/interfaces/points';
import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  ViewChild,
  computed,
  inject,
  signal,
} from '@angular/core';
import { catchError, count, filter, forkJoin, Subscription, map } from 'rxjs';
import { Box } from 'src/app/shared/models/box';
import * as async from 'async';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'primeng/dynamicdialog';
import { DataService } from 'src/app/core/services/data.service';
import { ApiService } from 'src/app/core/services/api.service';
import { Status_Point } from 'src/app/shared/models/status_point';
import * as _ from 'underscore';
import { Title } from '@angular/platform-browser';
import { SessionStorageService } from 'src/app/core/services/sessionStorage.service';
import { DashboardTypes } from 'src/app/shared/models/api-request/me.models';
import { UserRightsService } from 'src/app/core/services/user-rights.service';
import { TranslateService } from '@devinforius/super-compos-17';
import { IDelibeGlobalService } from 'src/app/core/services/idelibe/global.service';
import { IDelibeMeService } from 'src/app/core/services/idelibe/me.service';
import { DisplayLayout } from '@shared/types/dev';
import { IButton } from '@devinforius/i-essentials';
import { PointsAdvancedSearchQuery } from '@shared/types/points';
import { PointsAdvancedSearchService } from './points-advanced-search/services/points-advanced-search.service';
import { PersonalParamDto } from '@shared/interfaces/dtos/params';
@Component({
  selector: 'app-points',
  templateUrl: './points.component.html',
  styleUrls: ['./points.component.scss'],
})
export class PointsComponent implements OnInit, OnDestroy, AfterViewInit {
  private readonly pointsAdvancedSearchService = inject(PointsAdvancedSearchService);
  @ViewChild('pointSearchInput') pointSearchInput: ElementRef;

  public pointSearch = '';
  public boxes: Array<Box[]> = [];
  public statutsPoints: Array<Status_Point>;
  subscription: Subscription;
  public searchExist: boolean = false;
  public countsTags: any;
  public justifyOptions: Array<any> = [
    { icon: 'icon-side-view', value: 'side-by-side' },
    { icon: 'fas fa-align-justify', value: 'table' },
  ];
  public currentLayout = signal<DisplayLayout>('side-by-side');
  public currentDisposition: string = 'side-by-side';
  public currentRoute = 'searchTab/mesPointsEnRedaction';
  public buttons = signal<IButton[]>([]);
  public isUserAbleToAddPoint: boolean = false;
  public isUserHasRightToImport3P: boolean = false;
  public showOverlayDropdown: boolean = false;
  public onFocusInput = false;
  public dropdownValue: string = 'Titre';
  public dropdownLabel: string = 'Titre';
  public searchString: string = '';
  public advancedSearchDatas = null;
  public activeModeSearch = 'normalSearch';
  public checkContenuRTF: boolean;

  public readonly pointsCategories = signal<PointCategory[][]>([]);
  public readonly showAdvancedSearch = signal<boolean>(false);

  constructor(
    private router: Router,
    private translate: TranslateService,
    public dialog: DialogService,
    public dataService: DataService,
    private api: ApiService,
    private IDelibeMeService: IDelibeMeService,
    private IDelibeGlobalService: IDelibeGlobalService,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private storageService: SessionStorageService,
    public userRightsService: UserRightsService
  ) {}

  @HostListener('window:resize', []) updateResize() {
    if (window.innerWidth <= 1024) {
      this.currentDisposition = 'table';
    } else {
      this.currentDisposition = 'side-by-side';
    }
  }

  ngOnInit(): void {
    this.titleService.setTitle('iDélibé - Points');

    this.fetchPointsCategories();

    async.waterfall(
      [
        async (callback) => {
          this.isUserAbleToAddPoint = await this.userRightsService.getUserAbleToAddPoint();
          this.buttons.set([
            this.isUserAbleToAddPoint
              ? {
                  text: this.translate.translate('btn.createPoint'),
                  styleClass: 'green',
                  icon: 'fas fa-plus-circle',
                  iconPosition: 'left',
                  id: 'createNewPoint',
                  click: () => {
                    this.dataService.SetCurrentMeeting(null);
                    this.createNewPoint();
                  },
                }
              : null,
            {
              text: this.translate.translate('advancedSearch'),
              styleClass: 'blue',
              icon: 'bi bi-search',
              iconPosition: 'left',
              id: 'advancedSearchPoint',
              click: () => {
                this.toggleAdvancedSearch();
              },
            },
          ]);
          callback();
        },
      ],
      () => {
        this.router.navigate(['/private/points/searchTab/all']);
        if (!this.storageService.keyExists('reloadDashboardPoints')) {
          this.storageService.saveData('reloadDashboardPoints', '0');
        }
        this.dataService.setSidebarSmall(true);
        this.getData();
      }
    );
  }

  ngAfterViewInit() {
    this.pointSearchInput.nativeElement.focus();
  }

  ngOnDestroy(): void {
    this.currentRoute = null;
  }

  createNewPoint() {
    this.router.navigateByUrl('/private/points/create');
  }

  private fetchPointsCategories(): void {
    forkJoin({
      pointsStatuses: this.IDelibeGlobalService.getGlobalAllPointsStatuts().pipe(catchError(() => [])),
      pointsCategoriesCounts: this.api
        .getPointsCount('PourInfo,PourAction,ACorriger,EnRedaction')
        .pipe(catchError(() => ({}) as any)),
      pointsSavedSearches: this.IDelibeMeService.getPersonalParams(
        DashboardTypes.IDelibeBackofficeRechercheSauvegardee
      ).pipe(catchError(() => [])),
    }).subscribe(({ pointsStatuses, pointsCategoriesCounts, pointsSavedSearches }) => {
      this.statutsPoints = pointsStatuses.filter((status) => !!status.utilisable);
      this.countsTags = pointsCategoriesCounts;

      this.pointsCategories.set([
        [
          {
            label: this.translate.translate('title.allPoints'),
            onClick: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/all';
              this.router.navigate(['/private/points/searchTab/all']);
            },
          },
          {
            label: this.translate.translate('title.aCorriger'),
            count: this.countsTags.aCorriger,

            onClick: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/aCorriger';
              this.router.navigate(['/private/points/searchTab/aCorriger']);
            },
          },
          {
            label: this.translate.translate('title.pourInfo'),
            count: this.countsTags.pourInfo,

            onClick: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/pourInfo';
              this.router.navigate(['/private/points/searchTab/pourInfo']);
            },
          },
          {
            label: this.translate.translate('title.mesPointsEnRedaction'),
            count: this.countsTags.enRedaction,
            onClick: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/mesPointsEnRedaction';
              this.router.navigate(['/private/points/searchTab/mesPointsEnRedaction']);
            },
          },
          {
            label: this.translate.translate('title.pourAction'),
            count: this.countsTags.pourAction,
            onClick: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/pourAction';
              this.router.navigate(['/private/points/searchTab/pourAction']);
            },
          },
        ],
      ]);

      const mappedPointsCategories = this.statutsPoints.map(
        (status) =>
          ({
            label: status.description,
            onClick: () => {
              this.dataService.advancedSearchPoint = null;
              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.dataService.advancedSearchPoint = {
                InclureAnnuler: status.statutAutiliserLorsDeAnnulation ?? undefined,
                StatutIds: status.id,
              };
              this.searchExist = false;
              this.currentRoute = 'searchTab/' + status.id;
              this.router.navigate(['/private/points/searchTab/' + status.id]);
            },
          }) as PointCategory
      );

      const mappedSavedSearches = pointsSavedSearches
        .filter((param) => !param.hideInDashboard)
        .map((savedSearch) => ({
          label: savedSearch.description,
          onClick: () => {
            this.router.navigate(['/private/points/searchTab/reset']);
            setTimeout(() => {
              this.dataService.advancedSearchPoint = this.removeEmpty(JSON.parse(savedSearch.value));
              this.pointsAdvancedSearchService.setCurrentSearch(JSON.parse(savedSearch.value));
              const route = '/private/points/search/advancedSearch';
              this.router.navigate([route]);
            }, 1000);
          },
        }));

      this.pointsCategories.update((pointsCategories) => [...pointsCategories, mappedPointsCategories]);

      if (mappedSavedSearches.length) {
        this.pointsCategories.update((pointsCategories) => [...pointsCategories, mappedSavedSearches]);
      }
    });
  }

  getData() {
    let tempBoxes = [];
    const tempSearchSavedBoxes = [];
    async.waterfall([
      (callback) => {
        this.IDelibeGlobalService.getGlobalAllPointsStatuts().subscribe((res: any) => {
          this.statutsPoints = res;
          callback();
        });
      },
      (callback) => {
        this.api.getPointsCount('PourInfo,PourAction,ACorriger,EnRedaction').subscribe((res: any) => {
          this.countsTags = res;
          callback();
        });
      },
      (callback) => {
        this.boxes = [];
        //! Quand on fait un changement ds le code des box => delete dans sessionStorage boxesiDelibeBOv1 afin de forcer le reload avec l'envoi de l'input!
        tempBoxes = [
          {
            name: 'title.allPoints',
            menu: 'all',
            title: this.translate.translate('title.allPoints'),
            id: 'all',
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/all';
              this.router.navigate(['/private/points/searchTab/all']);
            },
          },
          {
            name: 'title.aCorriger',
            menu: 'aCorriger',
            count: this.countsTags.aCorriger,
            title: this.translate.translate('title.aCorriger'),
            id: 'aCorriger',
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/aCorriger';
              this.router.navigate(['/private/points/searchTab/aCorriger']);
            },
          },
          {
            name: 'title.pourInfo',
            menu: 'pourInfo',
            count: this.countsTags.pourInfo,
            title: this.translate.translate('title.pourInfo'),
            id: 'pourInfo',
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/pourInfo';
              this.router.navigate(['/private/points/searchTab/pourInfo']);
            },
          },
          {
            name: 'title.pourAction',
            menu: 'pourAction',
            count: this.countsTags.pourAction,
            title: this.translate.translate('title.pourAction'),
            id: 'pourAction',
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/pourAction';
              this.router.navigate(['/private/points/searchTab/pourAction']);
            },
          },
          {
            name: 'title.mesPointsEnRedaction',
            menu: 'mesPointsEnRedaction',
            count: this.countsTags.enRedaction,
            title: this.translate.translate('title.mesPointsEnRedaction'),
            id: 'mesPointsEnRedaction',
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.searchExist = false;
              this.currentRoute = 'searchTab/mesPointsEnRedaction';
              this.router.navigate(['/private/points/searchTab/mesPointsEnRedaction']);
            },
          },
        ];
        this.statutsPoints.map((statut) => {
          tempBoxes.push({
            name: statut.description,
            menu: statut.id,
            title: statut.description,
            id: statut.id.toString(),
            click: () => {
              this.dataService.advancedSearchPoint = null;

              this.pointsAdvancedSearchService.emptyCurrentSearch();
              this.dataService.advancedSearchPoint = {
                InclureAnnuler: statut.statutAutiliserLorsDeAnnulation ?? undefined,
                StatutIds: statut.id,
              };
              this.pointsAdvancedSearchService.setCurrentSearch({
                InclureAnnuler: statut.statutAutiliserLorsDeAnnulation ?? undefined,
                StatutIds: statut.id.toString(),
              });
              this.searchExist = false;
              this.currentRoute = 'searchTab/' + statut.id;
              this.router.navigate(['/private/points/searchTab/' + statut.id]);
            },
          });
        });

        callback();
      },
      (callback) => {
        const fromIcourrierCreation = localStorage.getItem('iDelibe_icourrier_id_send');
        if (this.activatedRoute.children.length === 0 && !fromIcourrierCreation) {
          this.currentRoute = 'searchTab/mesPointsEnRedaction';
          this.router.navigateByUrl('/private/points/searchTab/mesPointsEnRedaction');
        }
        callback();
      },
      (cb) => {
        if (window.innerWidth <= 1024) {
          this.currentDisposition = 'table';
        } else {
          this.currentDisposition = 'side-by-side';
        }
        cb();
      },
      (cb) => {
        if (this.dataService.advancedSearchPoint !== null || this.pointsAdvancedSearchService.hasActiveSearch()) {
          this.searchExist = true;
        }
        cb(null);
      },
      (cb) => {
        this.IDelibeMeService.getPersonalParams(DashboardTypes.IDelibeBackofficeRechercheSauvegardee)
          .toPromise()
          .then((res) => {
            res.map((x) => {
              if (x.hideInDashboard === false) {
                tempSearchSavedBoxes.push({
                  menu: x.name,
                  title: x.description,
                  name: x.description,
                  iud: x.id,
                  value: JSON.parse(x.value),
                  click: () => {
                    this.router.navigate(['/private/points/searchTab/reset']);
                    setTimeout(() => {
                      this.dataService.advancedSearchPoint = this.removeEmpty(JSON.parse(x.value));
                      this.pointsAdvancedSearchService.setCurrentSearch(JSON.parse(x.value));
                      const route = '/private/points/search/advancedSearch';
                      this.router.navigate([route]);
                    }, 1000);
                  },
                });
              }
            });
            cb(null);
          });
        this.boxes.push(tempBoxes, tempSearchSavedBoxes);
      },
    ]);
  }

  changeDisplay() {
    if (this.currentLayout() === 'table') {
      if (this.dataService.advancedSearchPoint || this.pointsAdvancedSearchService.hasActiveSearch()) {
        const route = '/private/points/display/search/advancedSearch';
        this.router.navigate([route], { queryParams: { CheckContenuRTF: this.checkContenuRTF } });
      } else {
        const route = '/private/points/display/' + this.currentRoute;
        this.router.navigate([route], { queryParams: { CheckContenuRTF: this.checkContenuRTF } });
      }
    }
  }

  searchPoint() {
    //on reset la recherche avancée
    this.dataService.advancedSearchPoint = null;
    this.pointsAdvancedSearchService.emptyCurrentSearch();
    this.searchExist = false;

    if (this.pointSearch) {
      this.pointSearch = this.pointSearch.trim();
      if (this.dropdownValue === 'Titre + Contenus') {
        this.checkContenuRTF = true;
        this.router.navigate(['/private/points/search/' + encodeURIComponent(this.pointSearch)], {
          queryParams: { CheckContenuRTF: true },
        });
        this.currentRoute = 'search/' + this.pointSearch;
      } else if (this.dropdownValue === 'Id') {
        if (/^\d+$/.test(this.pointSearch)) {
          const id = `**${this.pointSearch.toString()}`;
          this.checkContenuRTF = false;
          this.router.navigate(['/private/points/search/' + id], { queryParams: { CheckContenuRTF: false } });
          this.currentRoute = 'search/' + id;
        }
      } else {
        this.checkContenuRTF = false;
        this.router.navigate(['/private/points/search/' + encodeURIComponent(this.pointSearch)], {
          queryParams: { CheckContenuRTF: false },
        });
        this.currentRoute = 'search/' + this.pointSearch;
      }
    } else {
      this.router.navigate(['/private/points/searchTab/all']);
    }
  }

  public onPointSearchChange(search: string): void {
    if (!search.trim().length) this.router.navigate(['/private/points/searchTab/all']);
  }

  onToggleAdvancedSearch() {
    this.toggleAdvancedSearch();
  }

  private toggleAdvancedSearch(): void {
    this.showAdvancedSearch.set(!this.showAdvancedSearch());

    this.buttons.update((buttons) => [
      buttons[0],
      {
        ...buttons[1],
        styleClass: this.showAdvancedSearch() ? 'red' : 'blue',
        icon: this.showAdvancedSearch() ? 'bi bi-x' : 'bi bi-search',
        text: this.showAdvancedSearch()
          ? this.translate.translate('cancelAdvancedSearch')
          : this.translate.translate('advancedSearch'),
      },
    ]);

    if (!this.showAdvancedSearch()) {
      this.reset();
    }
  }

  reset() {
    this.dataService.advancedSearchPoint = null;

    this.pointsAdvancedSearchService.emptyCurrentSearch();
    this.searchExist = false;
    this.router.navigateByUrl('/private/points/searchTab/mesPointsEnRedaction');
  }

  removeEmpty(obj) {
    return Object.keys(obj)
      .filter(function (k) {
        return obj[k] != null;
      })
      .reduce(function (acc, k) {
        if (!Array.isArray(obj[k]) && !(obj[k] instanceof Date)) {
          acc[k] = typeof obj[k] === 'object' ? this.removeEmpty(obj[k]) : obj[k];
        } else {
          acc[k] = obj[k];
        }
        return acc;
      }, {});
  }

  // onSearchButtonClick() {}

  onClickDropdownInput(type: string) {
    this.dropdownLabel = type;
    this.dropdownValue = type;
    this.showOverlayDropdown = false;

    this.onPointSearchChange('');
  }

  public searchPoints(search: PointsAdvancedSearchQuery): void {
    this.onToggleAdvancedSearch();
    this.searchExist = true;
    this.pointsAdvancedSearchService.search(search);
  }

  public onLoadSavedSearch(savedSearch: PersonalParamDto): void {
    this.onToggleAdvancedSearch();
    this.searchExist = true;
    this.pointsAdvancedSearchService.searchFromASavedSearch(savedSearch);
  }

  public onRefreshDashboard(): void {
    this.fetchPointsCategories();
  }

  public emptySearch(): void {
    this.pointSearch = '';
    this.dataService.advancedSearchPoint = null;
    this.searchExist = false;
  }
}
